import { Input } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'Input.TextArea',
    component: Input,
});
